import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToExcel = (apiData) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
  };

  const sanitize = (value) => {
    return value ? value : "-";
  };

  const filteredData = apiData.map((item) => ({
    'Name': sanitize(item.name),
    'Email': sanitize(item.email),
    'Mobile': sanitize(item.mobile),
    'Referral Code': sanitize(item.referralCode),
    'Use Referral Code': sanitize(item.useReferralCode),
    'Last Logged': formatDate(item.lastLogged),
    'Register Date': formatDate(item.createdAt),
  }));

  const worksheet = XLSX.utils.json_to_sheet(filteredData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Customers');

  // Styling headers
  const columnWidths = Object.keys(filteredData[0] || {}).map(key => ({ wch: key.length + 15 }));
  worksheet['!cols'] = columnWidths;
  const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
    if (!worksheet[cellAddress]) continue;
    worksheet[cellAddress].s = {
      font: { bold: true },
      alignment: { horizontal: "center" }
    };
  }

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, 'Customers.xlsx');
};
